
export const EXPERTISE_LEVELS = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'] as const

export type ExpertiseLevel = (typeof EXPERTISE_LEVELS)[number]


export const CUISINE = [
    'ITALIAN',
    'MEXICAN',
    'CHINESE',
    'AMERICAN',
    'FRENCH',
    'INDIAN',
    'MEDITERRANEAN',
    'JAPANESE',
    'THAI',
    'TURKISH',
    'BALKANIAN',
    'PAKISTANI',
    'BULGARIAN'
] as const
export const STORAGE = ['DRY_STORAGE', 'FRIDGE', 'FROZEN'] as const
export const STATUS = ['DRAFT', 'PUBLISHED'] as const
